const fallbackApiUrl = "https://localhost:7074/api";
const configuredApiUrl = process.env.REACT_APP_API_URL?.trim();

const API_URL = (configuredApiUrl || fallbackApiUrl).replace(/\/+$/, "");

export { API_URL };
